import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { BackButton, ForwardButton } from '../../component/atom/Button';
import Header from '../../component/atom/Header';
import { Dollar } from '../../component/atom/Icon';
import Modal from '../../component/composite/Modal';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { APP } from '../../config/app';
import { MODAL_TYPE } from '../../config/modal';
const DEFAULT_ICON_STYLE = {
    width: '18px',
    height: '18px',
    marginRight: '3px',
    color: SEMANTIC_COLORS.ACCENT_ICON,
};
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/detailConfirmation'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/detailConfirmation'].title}/>);
const renderTimeSlotListSection = ({ isAllDay, careOrderBabyFormForDetailConfirmationPage, timeSlotFeeDataForDetailConfirmationPage, }) => {
    if (!timeSlotFeeDataForDetailConfirmationPage)
        return (<S.LayoutCardSection>
        <S.CardSectionTitle>預約資訊</S.CardSectionTitle>
        <S.CardNoData>您尚未選擇服務時段，請回到上一步填寫</S.CardNoData>
      </S.LayoutCardSection>);
    if (isAllDay)
        return (<S.LayoutCardSection>
        <S.CardSectionTitle>預約資訊</S.CardSectionTitle>
        <S.Card>
          <S.CardBody>
            <S.LayoutCardItems isLast>
              <S.CardItem>
                {careOrderBabyFormForDetailConfirmationPage.parsedAllDayTimeSlot}
              </S.CardItem>
              <S.CardItem>
                <Dollar style={DEFAULT_ICON_STYLE}/>
                {timeSlotFeeDataForDetailConfirmationPage.parsedDailyFee} / 天
              </S.CardItem>
            </S.LayoutCardItems>
          </S.CardBody>
        </S.Card>
      </S.LayoutCardSection>);
    return (<S.LayoutCardSection>
      <S.CardSectionTitle>預約資訊</S.CardSectionTitle>
      <S.Card>
        <S.CardBody>
          {careOrderBabyFormForDetailConfirmationPage.parsedPartTimeTimeSlotList.map((parsedTimeSlot, i) => (<S.LayoutCardItems key={parsedTimeSlot} isLast={i ===
                careOrderBabyFormForDetailConfirmationPage.parsedPartTimeTimeSlotList.length - 1}>
                <S.CardItem>{parsedTimeSlot}</S.CardItem>
                <S.CardItem>
                  <Dollar style={DEFAULT_ICON_STYLE}/>
                  {timeSlotFeeDataForDetailConfirmationPage.parsedExpectedTotalFee}
                </S.CardItem>
              </S.LayoutCardItems>))}
        </S.CardBody>
      </S.Card>
    </S.LayoutCardSection>);
};
const renderTimeSlotFeeSection = ({ isAllDay, timeSlotFeeDataForDetailConfirmationPage, parsedAllDayPlatformFeePercentage, parsedPartTimePlatformFeePercentage, }) => {
    if (!timeSlotFeeDataForDetailConfirmationPage)
        return (<S.LayoutCardSection>
        <S.CardSectionTitle>預約資訊</S.CardSectionTitle>
        <S.CardNoData>您尚未選擇服務時段，請回到上一步填寫</S.CardNoData>
      </S.LayoutCardSection>);
    if (isAllDay)
        return (<S.LayoutCardSection>
        <S.CardSectionTitle>預估費用</S.CardSectionTitle>
        <S.Card>
          <S.CardBody>
            <S.LayoutCardItems>
              <S.CardItem>
                <S.LayoutJustifyBetween>
                  <div>單日照顧費用</div>
                  <div>{timeSlotFeeDataForDetailConfirmationPage.parsedDailyServiceFee}</div>
                </S.LayoutJustifyBetween>
              </S.CardItem>
              <S.CardItem>
                <S.LayoutJustifyBetween>
                  <div>平台服務費({parsedAllDayPlatformFeePercentage})</div>
                  <div>{timeSlotFeeDataForDetailConfirmationPage.parsedDailyPlatformFee}</div>
                </S.LayoutJustifyBetween>
              </S.CardItem>
            </S.LayoutCardItems>
            <S.LayoutTotalFee>
              <span>
                <Dollar style={DEFAULT_ICON_STYLE}/>
                單日照顧費用
              </span>
              <span>{timeSlotFeeDataForDetailConfirmationPage.parsedDailyFee}</span>
            </S.LayoutTotalFee>
            <S.LayoutNotes>
              {timeSlotFeeDataForDetailConfirmationPage.parsedExtraChargeItemList ? (<div>
                  ＊照顧費用已含加價項目：
                  {timeSlotFeeDataForDetailConfirmationPage.parsedExtraChargeItemList}
                </div>) : null}
              <div>＊系統收費將以照服員打卡實際時數計算</div>
            </S.LayoutNotes>
          </S.CardBody>
        </S.Card>
      </S.LayoutCardSection>);
    return (<S.LayoutCardSection>
      <S.CardSectionTitle>預估費用</S.CardSectionTitle>
      <S.Card>
        <S.CardBody>
          <S.LayoutCardItems>
            <S.CardItem>
              <S.LayoutJustifyBetween>
                <div>照顧費用</div>
                <div>
                  {timeSlotFeeDataForDetailConfirmationPage.parsedSummedExpectedTotalServiceFee}
                </div>
              </S.LayoutJustifyBetween>
            </S.CardItem>
            <S.CardItem>
              <S.LayoutJustifyBetween>
                <div>平台服務費({parsedPartTimePlatformFeePercentage})</div>
                <div>
                  {timeSlotFeeDataForDetailConfirmationPage.parsedSummedExpectedTotalPlatformFee}
                </div>
              </S.LayoutJustifyBetween>
            </S.CardItem>
          </S.LayoutCardItems>
          <S.LayoutTotalFee>
            <span>
              <Dollar style={DEFAULT_ICON_STYLE}/>
              總價
            </span>
            <span>{timeSlotFeeDataForDetailConfirmationPage.parsedSummedExpectedTotalFee}</span>
          </S.LayoutTotalFee>
          <S.LayoutNotes>
            {timeSlotFeeDataForDetailConfirmationPage.parsedExtraChargeItemList ? (<div>
                ＊照顧費用已含加價項目：
                {timeSlotFeeDataForDetailConfirmationPage.parsedExtraChargeItemList}
              </div>) : null}
            <div>＊系統收費將以照服員打卡實際時數計算</div>
          </S.LayoutNotes>
        </S.CardBody>
      </S.Card>
    </S.LayoutCardSection>);
};
const renderActionButtonSection = ({ isForwardButtonAvailable, handleBackButtonClick, handleForwardButtonClick, }) => (<S.LayoutActionButtonSection>
    <BackButton onButtonClick={handleBackButtonClick} isAvailable size={BUTTON_SIZE.LARGE}>
      上一步
    </BackButton>
    <S.LayoutForwardButton>
      <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable={isForwardButtonAvailable} onButtonClick={handleForwardButtonClick}>
        派出案件
      </ForwardButton>
      <div>您不會被收費</div>
    </S.LayoutForwardButton>
  </S.LayoutActionButtonSection>);
const renderModals = ({ modalType, handleConfirmInvalidTimeSlotList, handleConfirmExpiredCareClientVisitor, }) => {
    switch (modalType) {
        case MODAL_TYPE.CLOSE:
            return null;
        case MODAL_TYPE.CARE_ORDER_BABY_INIT_ERROR_BAD_PARAMS_TIME_SLOT_LIST:
            return (<Modal content='已超過系統設定預計開始時間，請返回修改派案資料。' yesButtonTitle='修改資料' yesButtonSize={BUTTON_SIZE.LARGE} onYesButtonClick={handleConfirmInvalidTimeSlotList} isError/>);
        case MODAL_TYPE.CARE_ORDER_BABY_INIT_ERROR_CARE_CLIENT_VISITOR_EXPIRED:
            return (<Modal content='操作時間過長，請重新填寫資料。' yesButtonTitle='重新填寫' yesButtonSize={BUTTON_SIZE.LARGE} onYesButtonClick={handleConfirmExpiredCareClientVisitor} isError/>);
        default:
            throw new Error(`Unexpected modal type: ${modalType} on /detailConfirmation page`);
    }
};
export default function View({ 
// data
isLoading, isAllDay, isForwardButtonAvailable, careOrderBabyFormForDetailConfirmationPage, timeSlotFeeDataForDetailConfirmationPage, parsedAllDayPlatformFeePercentage, parsedPartTimePlatformFeePercentage, modalType, 
// func
handleBackButtonClick, handleForwardButtonClick, handleConfirmInvalidTimeSlotList, handleConfirmExpiredCareClientVisitor, }) {
    const header = useMemo(() => renderHeader(), []);
    const timeSlotListSection = useMemo(() => renderTimeSlotListSection({
        isAllDay,
        careOrderBabyFormForDetailConfirmationPage,
        timeSlotFeeDataForDetailConfirmationPage,
    }), [
        isAllDay,
        careOrderBabyFormForDetailConfirmationPage,
        timeSlotFeeDataForDetailConfirmationPage,
    ]);
    const timeSlotFeeSection = useMemo(() => renderTimeSlotFeeSection({
        isAllDay,
        timeSlotFeeDataForDetailConfirmationPage,
        parsedAllDayPlatformFeePercentage,
        parsedPartTimePlatformFeePercentage,
    }), [
        isAllDay,
        timeSlotFeeDataForDetailConfirmationPage,
        parsedAllDayPlatformFeePercentage,
        parsedPartTimePlatformFeePercentage,
    ]);
    const actionButtonSection = useMemo(() => renderActionButtonSection({
        handleBackButtonClick,
        handleForwardButtonClick,
        isForwardButtonAvailable,
    }), [handleBackButtonClick, handleForwardButtonClick, isForwardButtonAvailable]);
    const modals = useMemo(() => renderModals({
        modalType,
        handleConfirmInvalidTimeSlotList,
        handleConfirmExpiredCareClientVisitor,
    }), [modalType, handleConfirmInvalidTimeSlotList, handleConfirmExpiredCareClientVisitor]);
    return (<RWDPageLayout isLoading={isLoading}>
      {modals}
      {header}
      <S.Layout>
        {timeSlotListSection}
        {timeSlotFeeSection}
        {actionButtonSection}
      </S.Layout>
    </RWDPageLayout>);
}
